import { render, staticRenderFns } from "./qaSearch.vue?vue&type=template&id=1fde3bc4&scoped=true&"
import script from "./qaSearch.vue?vue&type=script&lang=js&"
export * from "./qaSearch.vue?vue&type=script&lang=js&"
import style0 from "./qaSearch.vue?vue&type=style&index=0&id=1fde3bc4&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fde3bc4",
  null
  
)

export default component.exports